'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getUi, hideModal } from '@/store/reducers/ui-slice';
import { Dialog } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Check as CheckIcon } from '@phosphor-icons/react/dist/ssr/Check';
import { useDispatch } from 'react-redux';

import { ModalDrawer } from '@/types/general';

export function ChartsModal({ type }: { type: ModalDrawer }): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  const dispatch = useDispatch();

  const handleClose = (): void => {
    dispatch(hideModal());
  };

  return (
    <Dialog onClose={handleClose} open={modal?.open === type}>
      <Paper sx={{ border: '1px solid var(--mui-palette-divider)', boxShadow: 'var(--mui-shadows-16)', p: 3 }}>
        <Stack spacing={3}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Avatar sx={{ bgcolor: 'var(--mui-palette-success-50)', color: 'var(--mui-palette-success-main)' }}>
              <CheckIcon fontSize="var(--Icon-fontSize)" />
            </Avatar>
          </Box>
          <Stack spacing={3}>
            <Stack spacing={1} sx={{ textAlign: 'center' }}>
              <Typography variant="h5">Payment successful</Typography>
              <Typography color="text.secondary" variant="body2">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident facere eum obcaecati pariatur magnam
                eius fugit nostrum sint enim, amet rem aspernatur distinctio tempora repudiandae, maiores quod. Ad,
                expedita
              </Typography>
            </Stack>
            <Stack direction="row" spacing={3}>
              <Button color="secondary" sx={{ flex: '1 1 auto' }}>
                Close
              </Button>
              <Button color="error" sx={{ flex: '1 1 auto' }} variant="contained">
                Refund
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
    </Dialog>
  );
}
